import React from 'react';
import { Trans } from 'react-i18next';

import { config } from '~/config';
import { useUserUpload } from '~/views/alfred/research/use-user-upload/useUserUpload';

import * as S from './UploadDisclaimer.styles';

export const UploadDisclaimer = () => {
  const files = useUserUpload(state => state.files);

  return (
    <S.UploadDisclaimer>
      {!!files.length && (
        <Trans
          i18nKey="chat:uploadDisclaimer"
          components={[
            <S.StyledAnchor
              key="key-0"
              href={config.urls.disclaimerFileUpload}
              target="_blank"
              rel="noreferrer noopener"
            />,
          ]}
        />
      )}
    </S.UploadDisclaimer>
  );
};
